export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE"
export const UPDATE_MESSENGER_BOX = "UPDATE_MESSENGER_BOX"